/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const FeePlanAgreementStatus = {
  Active: "active",
  Terminated: "terminated",
} as const;
export type FeePlanAgreementStatus = ClosedEnum<typeof FeePlanAgreementStatus>;

/** @internal */
export const FeePlanAgreementStatus$inboundSchema: z.ZodNativeEnum<
  typeof FeePlanAgreementStatus
> = z.nativeEnum(FeePlanAgreementStatus);
/** @internal */
export const FeePlanAgreementStatus$outboundSchema: z.ZodNativeEnum<
  typeof FeePlanAgreementStatus
> = FeePlanAgreementStatus$inboundSchema;
